module.exports = __webpack_public_path__ + "img/video.8c985604.svg";